export function getButtonClass(isActive?: boolean) {
  return `no-animation w-full bg-[#3c3c3c] hover:bg-primary hover:text-black ${isActive ? "bg-primary text-black" : "text-white"}`
}